import type { FC } from 'react';
import { lazy } from 'react';
import { PageSpinner } from 'src/components/spinner-container';
import {
  TsoMapProvider,
  useTsoMap,
} from 'src/pages/transport/fcfs-booking/direct/tso-map';

const Page = lazy(() => import('./page'));

const PageWithTsoMap: FC = () => {
  const tsoMap = useTsoMap();

  if (!tsoMap) return <PageSpinner />;

  return (
    <TsoMapProvider value={tsoMap}>
      <Page />
    </TsoMapProvider>
  );
};

export default PageWithTsoMap;
